<script lang="ts">
    export let amountSupporter;
    export let amountDonatedMoney;
    export let resultDate;
</script>

<section id="project-result-section">
    <div class="container">
        <h2 class="container__title">
            経過報告
        </h2>
        <div class="result-container">
            <div class="result-container__label">
                支援者数
            </div>
            <div class="result-container__body">
                <span class="result-container__body--number">{amountSupporter}</span>人
            </div>
        </div>
        <div class="result-container">
            <div class="result-container__label">
                支援金額
            </div>
            <div class="result-container__body">
                <span class="result-container__body--number">{amountDonatedMoney.toLocaleString()}</span>円
            </div>
        </div>
        <div class="result-container__bottom-message">
            ※学校、チームでお振込は1人で計算させていただいています。<br>
          {`※${resultDate.getFullYear()}年${resultDate.getMonth() + 1}月${resultDate.getDate()}日時点`}
        </div>
        <div class="amount-of-goal">
            <div class="amount-of-goal__title">目標金額</div>
            <div class="amount-of-goal__body">
                <span class="amount-of-goal__body--number">{(15000000).toLocaleString()}</span>円
            </div>
        </div>
        <div class="reason-of-goal">
            <div class="reason-of-goal__title">
                目標金額の設定理由
            </div>
            <ul class="reason-of-goal__list">
                <li>
                    現在の再生医療の終了後、専門のリハビリ施設への年内転院があること<br>
                    ※病院側のアドバイスを受けながら、本人とご家族で様々な方向性から転院先を考えています
                </li>
                <li>
                    今後別の再生医療を受ける際、保険適用外となり高額な治療費がかかること<br>
                </li>
                <li>
                    海外での最先端医療となれば、治療費に加え渡航費等の金額がかかること
                </li>
                <li>
                    治療費以外の部分でも、遠方でコロナ渦ということもあり病院での家族の付き添いも禁止されているため交通費に加え滞在費等もかかっていること
                </li>
                <li>
                    リハビリ期間を終えた後、社会復帰する際に支援が必要になること
                </li>
                <li>
                    保険対応が事故後2カ月分のみとなっているため、事故から4カ月が過ぎた現在、自費での支払いとなっていること
                </li>
            </ul>
            <div class=reason-of-goal__bottom-message>上記の内容から金額の設定をさせて頂きました。</div>
        </div>
    </div>
</section>

<style>
    #project-result-section {
        background-color: #ffffff;
        padding:            32px 0;
    }

    #project-result-section .container{
        margin:     0 auto;
        padding:    0 20px;
        text-align: center;
    }

    #project-result-section .container__title{
        font-size:     30px;
        font-weight:   bold;
        color:         #333333;
        margin-bottom: 56px;
    }
    
    #project-result-section .container__title:after {
        display:          block;
        position:         absolute;
        content:          "";
        height:           4px;
        width:            25%;
        background-color: #1a2382;
        transform:        translate(131%, 16px);
    }

    #project-result-section .result-container {
        display:          inline-block;
        width:            313px;
        margin-bottom:    16px;
        padding:          20px;
        background-color: #484f9a;
        color:            white;
        border-radius:    8px;
    }

    #project-result-section .result-container:first-of-type {
        margin-right: 16px;
    }

    #project-result-section .result-container__label {
        margin-bottom: 16px;
        font-size:     24px;
    }

    #project-result-section .result-container__label:after {
        content:          "";
        display:          block;
        width:            150px;
        height:           2px;
        background-color: white;
        border-radius:    1em;
        transform:        translate(80px, 8px);
    }

    #project-result-section .result-container__body {
        font-size:   24px;
        font-weight: bold;
    }

    #project-result-section .result-container__body--number {
        font-size: 40px;
    }

    #project-result-section .result-container__bottom-message {
        margin:     0 auto 64px;
        text-align: left;
    }

    #project-result-section .amount-of-goal {
        padding:          24px 0;
        margin:           0 auto 80px;
        border-radius:    1em;
        border:           4px dotted #de6c6c;
    }

    #project-result-section .amount-of-goal:after {
        content:          "";
        display:          block;
        width:            300px;
        height:           6px;
        margin:           0 auto;    
        background-color: #f69a9a;
        border-radius:    1em;
    }

    #project-result-section .amount-of-goal__title {
        display:      inline-block;
        margin-right: 16px;
        font-size:    32px;
        font-weight:  bold;
    }

    #project-result-section .amount-of-goal__body {
        display:       inline-block;
        margin-bottom: 8px;
        font-size:     26px;
    }

    #project-result-section .amount-of-goal__body--number{
        font-size:     48px;
        font-weight:   bold;
    }

    #project-result-section .reason-of-goal {
        text-align: left;
    }

    #project-result-section .reason-of-goal__title {
        margin-bottom: 16px;
        font-size:     24px;
        font-weight:   bold;
    }

    #project-result-section .reason-of-goal__list {
        margin:           0 0 16px;
        padding:          20px 20px 20px 32px;
        background-color: #e1e1e1;
        border-radius:    8px;
    }

    #project-result-section .reason-of-goal__list li:not(:last-child) {
        margin-bottom: 16px;
    }
</style>